import React from 'react';

import styles from './Button.module.css';

const Button = (props) => (
    <button 
        className={[styles.Button, styles[props.btnType], props.className].join(' ')}
        onClick={props.clicked || props.onClick}
        disabled={props.disabled} >
        {props.children}
    </button>
)

export default Button;